module.exports = __webpack_public_path__ + "static/img/iamge_nav_cancel@3x.ed4b539.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/iamge_nav_cancel@3x.png
// module id = 74
// module chunks = 18